function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M323.438,238.672c15.851-.339,26.5,5.224,39.453,7.812,4.194,0.838,13.167-.612,15.625,1.563,1.953,4.074,2.137,14.025,1.562,18.75-12.777,3.712-25.74-3.137-34.766-6.25-20.042-6.914-40.835-2.747-51.953,9.765l-1.953-.39C291.943,242.338,303.849,246.32,323.438,238.672Zm140.624,0.781c15.63-.365,35.179,2.253,41.016,11.719,2.311,3.747,1.207,14.132.781,17.969l-0.781.39-7.812-6.25c-6.594-4.256-19.618-8.321-30.469-6.25-9.94,1.9-37.845,15.13-47.656,11.328q-0.587-.39-1.172-0.781c-0.121-7.228.338-13.463,2.343-19.531,11.72,0.22,20.382-3.421,29.3-5.859Z"
});

var SvgMEyebrowshapeSVector = function SvgMEyebrowshapeSVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "m_eyebrowshape_s_vector",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMEyebrowshapeSVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/m_eyebrowshape_s_vector.eee0ccd0.svg";
export { ForwardRef as ReactComponent };